import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import store,{history} from 'store';
import {Provider} from "react-redux";
import {
    unstable_HistoryRouter as HistoryRouter,
    Link,
    Route,
    Routes,
    NavLink
} from "react-router-dom";
import auth0 from "auth0-js";
import { initModalTargetListener, setInnerTabLinkProvider } from "@netapp/bxp-design-system-react";
import "./modules/app/configureYup"
import { ThemeContextController } from "modules/app/ThemeContext";

const isIntegratedMFE = import.meta.env.VITE_IS_APP_INTEGRATED_MFE;
const isIframe = window.top !== window;
const loadedUnderBXP = isIntegratedMFE || isIframe; // remove iframe once shell is fully integrated as shadow dom

setInnerTabLinkProvider({ Link, NavLink });
if (!loadedUnderBXP) {
    window.auth0 = auth0;

    store.dispatch({
        type: "APP/BOOT"
    });
} else {
    store.dispatch({
        type: "APP/MINI-BOOT"
    });
}

history.listen(() => {
    window.scrollTo(0, 0);
});

initModalTargetListener();

const RedirectApiDoc = () => {
    window.location.replace(`${window.location.origin}/api-doc#pathname=${window.location.pathname.replace("/api-doc", "")}`);
    return <div/>
}

const RedirectStyleGuide = () => {
    window.location.replace(`${window.location.origin}/styleguide/index.html?path=${window.location.pathname}`)
    return <div/>
}

const FSXCoreApp = (props?: any) => {
	return (
		<Provider store={store}>
			<HistoryRouter history={history}>
				<ThemeContextController>
					<Routes>
						<Route path="/api-doc/*" element={<RedirectApiDoc />} />
						<Route path="/styleguide/*" element={<RedirectStyleGuide />} />
						<Route path="*" element={<App {...props} />} />
					</Routes>
				</ThemeContextController>
			</HistoryRouter>
		</Provider>
	);
};

if (!isIntegratedMFE) {
	import("@netapp/bxp-style/css/reset.css");
	import("@netapp/bxp-design-system-react/dist/index.css");
	ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
		<React.StrictMode>
			<FSXCoreApp />
		</React.StrictMode>
	);
}

export default FSXCoreApp;
